import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.pages.RentalVehicleLocationGarageConfirm.title',
    defaultMessage: 'Is your vehicle on the way to or currently at this garage?',
  },
  confirmAddressButton: {
    id: 'app.pages.RentalVehicleLocationGarageConfirm.confirm',
    defaultMessage: 'YES',
  },
  cancelAddressButton: {
    id: 'app.pages.RentalVehicleLocationGarageConfirm.cancel',
    defaultMessage: 'NO',
  },
});
